import { ClientRepo as clientRepo } from "../../clients/client.repo";
import { UsersRepo as usersRepo, UsersRepo } from "../../users/users.repo";
import { PortfolioRepo as portfolioRepo } from "../../portfolio/portfolio.repo";
import { PortfolioUtilities as portfolioUtilities } from "../../common/portfolio.utilities";
import * as _ from "lodash";
import * as echarts from "echarts";
import * as moment from "moment";
import { isNullOrUndefined } from "util";
import {
  AssetClassNames,
  AssetClassColour,
} from "../../common/enums/AssetClassType";
import bugsnagClient from "../../../bugsnag";
import { GraphColourArray } from "../../common/enums/GraphColours";
import { TrailingTwelveMonthsPerformance } from "../../portfolioadmin/reportManagement/models/TrailingTwelveMonthsPerformance";
import { Locality } from "../../cmodel/cmodel.repo";
import { TopHoldings } from "../topholdings";
import { PortfolioPerformance } from "../portfolioPerformance";
import {
  BenchmarkPerformance,
  BenchmarkPerformancePortfolio,
  LastTransaction,
  LastTransactionPortfolio,
} from "../benchmarkPerformance";
import { ClientBenchmarkColumnNames } from "../../clients/models/clientBenchmarkConfig";
import { ClientDetails } from "../../clients/models/clientDetailsModel";
import { StrategyInformation } from "../../clients/models/strategyInformation";
import {
  PortfolioCashTransactionDTO,
  LastTransactionDTO,
} from "../../portfolioadmin/performanceManagement/models/portfolioCashTransactionDto";
import { AttributionRepo } from "../../portfolioadmin/attribution/attribution.repo";
import { AssetClassPerformance, defaultAssetClassPerformances } from "../../portfolio/models/aggregatePortfolioItem";
import { defaultAssetClassNames, PortfolioAttributionContribution } from "../../portfolioadmin/models/PortfolioAttributionBenchmarkDto ";
import { BarChartStyleOption, getWaterfallOptions } from "../../common/waterfall-chart-options";
import { getNegativeBarGraphOptions } from "../../common/negative-bar-graph-options";

class PortfolioSummaryReportController implements angular.IOnInit {
  // Chart Variables:
  public assetClass: any;
  public assetClassChartHeight: any;
  public assetClassesTotal: any;

  public localAssetClass: any;
  public localAssetClassesTotal: any;
  public localAssetSummaryChartOptions: any;
  public localAssetSummaryChart: any;

  public localSectorItems: Array<any>;
  public localSectorChartOptions: any;
  public localSectorChart: any;

  public internationalAssetClass: any;
  public internationalAssetClassesTotal: any;
  public internationalAssetSummaryChartOptions: any;
  public internationalAssetSummaryChart: any;

  public internationalSectorItems: Array<any>;
  public internationalSectorChartOptions: any;

  public internationalGeographyItems: Array<any>;
  public internationalGeographyChartOptions: any;
  public internationalGeographyChart: any;

  public internationalCurrencyItems: Array<any>;
  public internationalCurrencyChartOptions: any;
  public internationalCurrencyChart: any;

  // --------------------------------------------
  // CurrencySplit
  // --------------------------------------------
  public currencyItems: Array<any>;
  public currencyChartOptions: any;
  public currencyChart: any;
  public currencyColorArray: any;
  // --------------------------------------------
  public regionalSummaryChart: any;
  public regionalSummaryChartOptions: any;
  public assetSummaryChart: any;
  public assetSummaryChartOptions: any;

  public inceptionPerformanceChart: any;
  public inceptionPerformanceChartOptions: any;

  // Portfolio Variables:
  public portfoliosData: any;

  // Performance Variables:
  public mauritiusTotal: any;
  public internationalTotal: any;
  public mauritiusPercentage: any;
  public internationalPercentage: any;
  public currencies: any;
  public performanceData: any;
  public trailingTwelveMonthsPerformance: TrailingTwelveMonthsPerformance;
  public financialYearToDate: TrailingTwelveMonthsPerformance;

  // colour variables:
  public confidentGrey = "#646363";
  public confidentRedTint = "#91c840";
  public confidentBrown = AssetClassColour.FIXED_INCOME;

  public localSectorColorArray: any;
  public internationalSectorColorArray: any;
  public internationalGeographyColorArray: any;
  public internationalCurrencyColorArray: any;

  // Report Variables:
  public portfolioIds: number[];
  public currency = "MUR";
  public reportRecipientName: string;
  public clientName: string;

  //performance date ranges

  public fromDate;
  public toDate;

  public quarterNumber;
  public quarterSuperScript;

  //  performance display
  public displayLocalPerformance: boolean;
  public displayInternationalPerformance: boolean;
  public displayMonthlyPerformance: boolean;
  public displayLineItems: boolean;
  public isReconciled: boolean;
  public inceptionPerf: boolean;
  public ttmPerf: boolean;
  public finYearToDate: boolean;
  public lastTransaction: boolean;
  public topHoldings: TopHoldings;
  public isCurrencySplitVisible: boolean;
  public equityItemsLocal: any;
  public equityItemsListLocal: any = [];
  public equitiesTotalLocal: any;

  public equityItemsInternational: any;
  public equityItemsListInternational: any = [];
  public equitiesTotalInternational: any;

  public fixedIncomeItemsLocal: any;
  public fixedIncomeItemsListLocal: any = [];
  public fixedIncomeTotalLocal: any;

  public fixedIncomeItemsInternational: any;
  public fixedIncomeItemsListInternational: any = [];
  public fixedIncomeTotalInternational: any;

  public preciousMetalItemsLocal: any;
  public preciousMetalItemsListLocal: any = [];
  public preciousMetalsTotalLocal: any;

  public preciousMetalItemsInternational: any;
  public preciousMetalItemsListInternational: any = [];
  public preciousMetalsTotalInternational: any;

  public alternativeInvestmentItemsLocal: any;
  public alternativeInvestmentItemsListLocal: any = [];
  public alternativeInvestmentsTotalLocal: any;

  public alternativeInvestmentItemsInternational: any;
  public alternativeInvestmentItemsListInternational: any = [];
  public alternativeInvestmentsTotalInternational: any;

  public cashItemsLocal: any;
  public cashItemsListLocal: any = [];
  public cashTotalLocal: any;

  public cashItemsInternational: any;
  public cashItemsListInternational: any = [];
  public cashTotalInternational: any;

  public allPortfolioHoldings: any[] = [];
  public inceptionPerfItems: any;

  public tableItemsSize = 6;
  // ---------   Benchmark ---------------------------------
  // public benchmarkPerformance: Array<BenchmarkPerformance> = [];
  public benchmarkPerformancePortfolio: BenchmarkPerformancePortfolio = {
    combined: [],
    local: [],
    international: [],
  };
  public lastTransactionPortfolio: LastTransactionPortfolio = {
    combined: [],
    local: [],
    international: [],
  };
  public displayBenchmarkPerformance: boolean;

  public combinedBenchmark: boolean;
  public localBenchmark: boolean;
  public internationalBenchmark: boolean;

  public combinedBenchmarkPrimary: boolean = false;
  public combinedBenchmarkSecondary: boolean = false;
  public localBenchmarkPrimary: boolean = false;
  public localBenchmarkSecondary: boolean = false;
  public internationalBenchmarkPrimary: boolean = false;
  public internationalBenchmarkSecondary: boolean = false;

  public primaryBenchmarkColumnName: string =
    ClientBenchmarkColumnNames.DefaultBenchmark;
  public secondaryBenchmarkColumnName: string = "";
  public isSecondaryBenchmarkColumnEnabled: boolean = false;
  public client: ClientDetails;

  // ------------------ ATTRIBUTION ---------------------
  public quarterDates: any;
  public portfolioPerfomanceForQuarter: any;
  public showPortfolioSummaryReportOnly: boolean = true;
  public portfolioTTM: TrailingTwelveMonthsPerformance;
  public attributionContributions: PortfolioAttributionContribution;
  public assetClassPerformanceTTM: AssetClassPerformance[] = [];
  public attributionByAssetClass: AssetClassPerformance[] = _.cloneDeep(
    defaultAssetClassPerformances
  );
  public assetClassPerformanceQuarter: AssetClassPerformance[] = [];

  public assetClassTtmPerfGraph;
  public assetClassQuarterPerfGraph;
  public attributionByAssetClassGraph;
  public assetClassTtmPerfGraphOptions;
  public assetClassQuarterPerfGraphOptions;
  public attributionByAssetClassGraphOptions;

  public quarterEndDate: any;
  public isFetchingPortfolioAttributions: boolean = false;

  // ------------- END ATTRIBUTION --------------------------

  public strategyGoingForward: boolean = false;
  public strategyInformation: StrategyInformation = {
    localStrategy: "",
    internationalStrategy: "",
    isLocalStrategyEnabled: false,
    isCombinedStrategyEnabled: false,
    isInternationalStrategyEnabled: false,
  };

  public cashTransaction: PortfolioCashTransactionDTO;

  scope: any;

  public hasPageLoaded = false;

  /** @ngInject */
  constructor(
    private clientRepo: clientRepo,
    private portfolioRepo: portfolioRepo,
    private portfolioUtilities: portfolioUtilities,
    private $state: angular.ui.IStateService,
    $scope: angular.IScope,
    private $stateParams: angular.ui.IStateParamsService,
    private usersRepo: usersRepo,
    private attributionRepo: AttributionRepo,
    private authService: any,
    private $timeout: angular.ITimeoutService
  ) {
    var chartHeight: any = "40%";
    var chartWidth = "50%";
    var that = this;
    that.assetClassChartHeight = "40%";
    that.topHoldings = new TopHoldings();
    // initialise the echarts component and then you can set the options later.
    // The dom element gets initialised and you can now set options and interact with the pie-chart

    this.showPortfolioSummaryReportOnly = this.isReportForPortfolioSummary();

    if (this.showPortfolioSummaryReportOnly) {
      this.initializePortfolioSummaryGraphs();
    } else {
      this.initializePortfolioAttributionGraphs();
    }

    // set the from data from the beggining of this year and the end date being the last months last day.
  }

  $onInit() {
    this.setGlobalParams();
    // Set the name to be displayed on the report:
    this.setReportRecipientName();

    if (this.showPortfolioSummaryReportOnly) {
      // set the display local performance flag to what you received from the url
      this.displayLocalPerformance =
        this.$stateParams.displayLocalPerformance === "true";

      // set the display international performance flag to what you received from the url
      this.displayInternationalPerformance =
        this.$stateParams.displayInternationalPerformance === "true";

      this.displayMonthlyPerformance =
        this.$stateParams.displayMonthlyPerformance === "true";

      this.displayLineItems = this.$stateParams.displayLineItems === "true";

      this.isReconciled = this.$stateParams.isReconciled === "true";
      this.inceptionPerf = this.$stateParams.inceptionPerf === "true";
      this.ttmPerf = this.$stateParams.trailingTwelveMonthsPerf === "true";
      this.finYearToDate = this.$stateParams.finYearToDate === "true";
      this.topHoldings.setChartDisplayToggleValues(this.$stateParams);

      this.isCurrencySplitVisible = this.$stateParams.currencySplit === "true";
      // ------------------------------------------------------------------------------
      // ------------- Benchmark ------------------------------------------------------
      // ------------------------------------------------------------------------------

      this.combinedBenchmark =
        (this.$stateParams.combinedBenchmark as string).toLowerCase() ===
        "true";
      this.localBenchmark =
        (this.$stateParams.localBenchmark as string).toLowerCase() === "true";
      this.internationalBenchmark =
        (this.$stateParams.internationalBenchmark as string).toLowerCase() ===
        "true";

      this.combinedBenchmarkPrimary =
        (this.$stateParams.combinedBenchmarkPrimary as string).toLowerCase() ===
        "true";
      this.localBenchmarkPrimary =
        (this.$stateParams.localBenchmarkPrimary as string).toLowerCase() ===
        "true";
      this.internationalBenchmarkPrimary =
        (
          this.$stateParams.internationalBenchmarkPrimary as string
        ).toLowerCase() === "true";
      this.combinedBenchmarkSecondary =
        (
          this.$stateParams.combinedBenchmarkSecondary as string
        ).toLowerCase() === "true";
      this.localBenchmarkSecondary =
        (this.$stateParams.localBenchmarkSecondary as string).toLowerCase() ===
        "true";
      this.internationalBenchmarkSecondary =
        (
          this.$stateParams.internationalBenchmarkSecondary as string
        ).toLowerCase() === "true";
      this.strategyGoingForward =
        (this.$stateParams.strategyGoingForward as string).toLowerCase() ===
        "true";
      this.lastTransaction =
        (this.$stateParams.lastTransaction as string).toLowerCase() === "true";
      // ------------------------------------------------------------------------------

      if (this.ttmPerf) this.updateTrailingTwelveMonthsPerformance();

      this.setQuarterNumber();

      this.getLocalSectorBreakdown();
      this.getInternationalGeographyBreakdown();
      this.getInternationalCurrencyBreakdown();
      // Update the performance data and the portfolio data
      this.getLocalAssetClassBreakdown();
      this.getInternationalAssetClassBreakdown();
      // Update the performance data and the portfolio data

      this.updatePerformanceData();
      this.updatePortfolioData();
      this.getBenchmarkPortfolioPerformance();

      if (this.inceptionPerf === true) {
        this.getInceptionPerf();
      }

      if (this.lastTransaction === true) {
        this.getLastTransactions();
      }
    } else {
      this.getPortfolioAttributionGraphs();
    }

    if (this.$stateParams["clientNumber"]) {
      this.clientRepo
        .getClient(this.$stateParams["clientNumber"])
        .then((val) => {
          this.client = val.data as ClientDetails;
          this.setBenchmarkColumns();
          this.setStrategyGoingForward();
          if (this.finYearToDate) this.getFinancialYearToDatePerformance();
        })
        .catch((err) => {});
    }

    if (!this.$stateParams["clientNumber"] && this.strategyGoingForward) {
      this.clientRepo
        .getClient(this.$stateParams["clientNumber"])
        .then((val) => {
          this.client = val.data as ClientDetails;
          this.setBenchmarkColumns();
          this.setStrategyGoingForward();
        })
        .catch((err) => {});
    }
  }

  private setReportRecipientName() {
    // 'clients' or 'users' folders on S3 bucket.
    // console.log(
    //   "this.$stateParams['clientNumber']",
    //   this.$stateParams["clientNumber"]
    // );
    if (this.$stateParams["clientNumber"]) {
      this.clientRepo
        .getClientReportingName(this.$stateParams["clientNumber"])
        .then((response) => {
          let client = response.data as any;
          this.clientName = client;
          let reportType = this.isReportForPortfolioSummary()
            ? "Summary"
            : "Attribution";
          this.reportRecipientName = `Portfolio ${reportType} Report for  ${client}`;
        })
        .catch((err) =>
          bugsnagClient.notify(`Error: ${err}`, {
            severity: "error",
            metaData: {
              clientNumber: this.$stateParams["clientNumber"],
            },
          })
        );
    } else {
      let userId = this.$stateParams["userId"];
      // console.log("userID", this.$stateParams["userId"]);
      this.usersRepo
        .getUser(userId)
        .then((response) => {
          let user = response.data as any;
          this.clientName = user.name;
          this.reportRecipientName = "Combined Report for " + user.name;
          // console.log(
          //   "this.reportRecipientName in user side ",
          //   this.reportRecipientName
          // );
        })
        .catch((err) =>
          bugsnagClient.notify(`Error: ${err}`, {
            severity: "error",
            metaData: {
              userId: this.$stateParams["userId"],
            },
          })
        );
    }
  }

  private setQuarterNumber() {
    let quarter = moment(this.toDate).utc().quarter();
    switch (quarter) {
      case 1:
        this.quarterNumber = "1";
        this.quarterSuperScript = "st";
        break;
      case 2:
        this.quarterNumber = "2";
        this.quarterSuperScript = "nd";
        break;
      case 3:
        this.quarterNumber = "3";
        this.quarterSuperScript = "rd";
        break;

      case 4:
        this.quarterNumber = "4";
        this.quarterSuperScript = "th";
        break;
      default:
        this.quarterNumber = "";
    }
  }

  async updatePortfolioData() {
    let that = this;
    this.portfolioRepo
      .getPortfolioAggregatesByLocality(
        null,
        this.currency,
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        that.portfoliosData = val;
        that.mauritiusTotal = 0;
        that.internationalTotal = 0;

        _.forEach(that.portfoliosData, (portfolio) => {
          if (portfolio.name == "Local")
            // Mauritius
            that.mauritiusTotal = portfolio.total;
          else that.internationalTotal = portfolio.total;
        });

        that.mauritiusPercentage =
          (that.mauritiusTotal /
            (that.mauritiusTotal + that.internationalTotal)) *
          100;
        that.internationalPercentage =
          (that.internationalTotal /
            (that.mauritiusTotal + that.internationalTotal)) *
          100;

        that.regionalSummaryChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                name: "Mauritius",
                value: that.mauritiusPercentage,
                itemStyle: {
                  normal: {
                    color: that.confidentGrey,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: "International",
                value: that.internationalPercentage,
                itemStyle: {
                  normal: {
                    color: that.confidentRedTint,
                    fontFamily: "Helvetica",
                  },
                },
              },
            ],
          },
        };

        // remove the 0 valued data from the pie chart
        this.regionalSummaryChartOptions.series.data = _.filter(
          this.regionalSummaryChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );

        that.regionalSummaryChart.setOption(that.regionalSummaryChartOptions);
      })
      .catch((err) => {});

    this.portfolioRepo
      .getPortfolioAggregatesByAssetClasses(
        null,
        this.currency,
        null,
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.assetClass = val as Array<any>;

        this.assetClassesTotal = _.reduce(
          this.assetClass,
          (prev, next) => {
            return prev + next.total;
          },
          0
        );

        this.assetSummaryChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                name: AssetClassNames.EQUITY,
                value: this.getAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.assetClass,
                    AssetClassNames.EQUITY
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.EQUITY,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.FIXED_INCOME,
                value: this.getAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.assetClass,
                    AssetClassNames.FIXED_INCOME
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.FIXED_INCOME,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.PRECIOUS_METALS,
                value: this.getAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.assetClass,
                    AssetClassNames.PRECIOUS_METALS
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.PRECIOUS_METALS,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.ALTERNATIVE_INV,
                value: this.getAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.assetClass,
                    AssetClassNames.ALTERNATIVE_INV
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.ALTERNATIVE_INV,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.CASH,
                value: this.getAssetClassPercentage(
                  this.getAssetClassTotal(this.assetClass, AssetClassNames.CASH)
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.CASH,
                    fontFamily: "Helvetica",
                  },
                },
              },
            ],
          },
        };
        // remove the 0 valued data from the pie chart
        that.assetSummaryChartOptions.series.data = _.filter(
          that.assetSummaryChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );
        that.assetSummaryChart.setOption(that.assetSummaryChartOptions);
      })
      .catch((err) => {});

    await Promise.all([
      this.getLocalEquityList(),
      this.getInternationalEquityList(),
      this.getLocalFixedIncomeList(),
      this.getInternationalFixedIncomeList(),
      this.getLocalPreciousMetalList(),
      this.getInternationalPreciousMetalList(),
      this.getLocalAlternativeInvestmentsList(),
      this.getInternationalAlternativeInvestmentList(),
      this.getLocalCashItemsList(),
      this.getInternationalCashItemsList(),
    ]);

    this.allPortfolioHoldings = _.sortBy(
      this.allPortfolioHoldings,
      (h) => h.marketValueDisplayCurrency
    ).filter((h) => h.marketValueDisplayCurrency > 0);
    this.topHoldings.setTotalPortfolio(this.allPortfolioHoldings);
    this.topHoldings.setReportTopPortfolioCharts();
  }

  public updatePerformanceData() {
    this.portfolioRepo
      .getPortfolioPerformance(
        this.currency,
        this.portfolioIds,
        this.fromDate,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.performanceData = val.data;
      })
      .catch((err) => {});
  }

  public updateTrailingTwelveMonthsPerformance() {
    this.portfolioRepo
      .getTrailingTwelveMonthsPerformance(
        this.currency,
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.trailingTwelveMonthsPerformance = val.data;
      })
      .catch((err) => {});
  }

  public getFinancialYearToDatePerformance() {
    this.portfolioRepo
      .getFinancialYearToDatePerformance(
        this.currency,
        this.portfolioIds,
        this.client.finYearStart,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.financialYearToDate = val.data;

        let financialYearToDateLocal: BenchmarkPerformance = {
          title: "FYTD",
          portfolioPerformance: this.financialYearToDate.local,
          benchmarkPerformancePrimary: this.financialYearToDate.localPrimaryBenchmark,
          benchmarkPerformanceSecondary: this.financialYearToDate.localSecondaryBenchmark,
        };

        let financialYearToDateInternational: BenchmarkPerformance = {
          title: "FYTD",
          portfolioPerformance: this.financialYearToDate.international,
          benchmarkPerformancePrimary: this.financialYearToDate.internationalPrimaryBenchmark,
          benchmarkPerformanceSecondary: this.financialYearToDate.internationalSecondaryBenchmark,
        };

        let financialYearToDateCombined: BenchmarkPerformance = {
          title: "FYTD",
          portfolioPerformance: this.financialYearToDate.combined,
          benchmarkPerformancePrimary: this.financialYearToDate.combinedPrimaryBenchmark,
          benchmarkPerformanceSecondary: this.financialYearToDate.combinedSecondaryBenchmark,
        };

        this.benchmarkPerformancePortfolio.local.push(financialYearToDateLocal);
        this.benchmarkPerformancePortfolio.international.push(financialYearToDateInternational);
        this.benchmarkPerformancePortfolio.combined.push(financialYearToDateCombined);

      })
      .catch((err) => {});
  }

  public formatCurrency(currencyCode: string) {
    return this.portfolioUtilities.formatCurrency(currencyCode);
  }

  public getAssetClassPercentage(assetClass) {
    return (assetClass.total / this.assetClassesTotal) * 100;
  }

  public getLocalAssetClassPercentage(assetClass) {
    return (assetClass.total / this.localAssetClassesTotal) * 100;
  }
  public getInternationalAssetClassPercentage(assetClass) {
    return (assetClass.total / this.internationalAssetClassesTotal) * 100;
  }

  public tranc(value) {
    return Math.trunc(value);
  }

  public commaSep(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  public stateChange(stateName: string) {
    this.$state.go(stateName);
    return;
  }

  public getCurrentDate() {
    let date = new Date();
    return date;
  }

  public getReportDate() {
    let date = this.toDate;
    return date;
  }

  public getLocalAssetClassBreakdown = () => {
    let that = this;

    this.portfolioRepo
      .getPortfolioAggregatesByAssetClasses(
        null,
        this.currency,
        "LOCAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.localAssetClass = val as Array<any>;

        this.localAssetClassesTotal = this.localAssetClass.reduce(
          (prev, curr) => {
            return prev + curr.total;
          },
          0
        );
        this.topHoldings.setLocalPortfolioValue(this.localAssetClassesTotal);

        this.localAssetSummaryChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                name: AssetClassNames.EQUITY,
                value: this.getLocalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.localAssetClass,
                    AssetClassNames.EQUITY
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.EQUITY,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.FIXED_INCOME,
                value: this.getLocalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.localAssetClass,
                    AssetClassNames.FIXED_INCOME
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.FIXED_INCOME,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.PRECIOUS_METALS,
                value: this.getLocalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.localAssetClass,
                    AssetClassNames.PRECIOUS_METALS
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.PRECIOUS_METALS,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.ALTERNATIVE_INV,
                value: this.getLocalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.localAssetClass,
                    AssetClassNames.ALTERNATIVE_INV
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.ALTERNATIVE_INV,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.CASH,
                value: this.getLocalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.localAssetClass,
                    AssetClassNames.CASH
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.CASH,
                    fontFamily: "Helvetica",
                  },
                },
              },
            ],
          },
        };

        // remove the 0 valued data from the pie chart
        that.localAssetSummaryChartOptions.series.data = _.filter(
          that.localAssetSummaryChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );
        that.localAssetSummaryChart.setOption(
          that.localAssetSummaryChartOptions
        );
      })
      .catch((err) => {});
  };

  public getLocalSectorBreakdown = () => {
    this.portfolioRepo
      .getPortfolioAggregatesBySector(
        this.currency,
        this.portfolioIds,
        this.toDate,
        "LOCAL",
        this.isReconciled
      )
      .then((result) => {
        this.localSectorItems = _.reverse(
          _.orderBy(result, (item: any) => {
            return item.total;
          })
        );
        let sectorItemsSorted = _.reverse(
          _.orderBy(this.localSectorItems, (item) => {
            return item.total;
          })
        );
        let localTopSectorInvestments: Array<any>;
        localTopSectorInvestments = sectorItemsSorted.splice(0, 5);
        let localOtherSectors = sectorItemsSorted.splice(
          0,
          sectorItemsSorted.length
        );
        if (localOtherSectors.length > 0) {
          let otherObject = {
            name: "Other",
            value: _.reduce(
              localOtherSectors,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
            total: _.reduce(
              localOtherSectors,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
          };
          localTopSectorInvestments.push(otherObject);
        }
        this.localSectorItems = localTopSectorInvestments;
        let count = -1;
        var localSectorPieChartData = _.map(this.localSectorItems, (item) => {
          count += 1;
          return {
            value: this.getLocalSectorPercentage(item),
            name: this.formatLongNames(item.name),
            itemStyle: {
              normal: {
                color: GraphColourArray[count],
                fontFamily: "Helvetica",
              },
            },
          };
        });
        this.localSectorChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: localSectorPieChartData,
          },
        };
        // remove the 0 valued data from the pie chart
        this.localSectorChartOptions.series.data = _.filter(
          this.localSectorChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );
        this.localSectorChart.setOption(this.localSectorChartOptions);
        this.localSectorColorArray = this.localSectorChart.getOption().color;
      });
  };
  getLocalSectorTotal = () => {
    return _.reduce(
      this.localSectorItems,
      (accumulator, item: any) => {
        accumulator += item.total;
        return accumulator;
      },
      0
    );
  };
  getLocalSectorPercentage = (item) => {
    return (item.total / this.getLocalSectorTotal()) * 100;
  };

  public getInternationalAssetClassBreakdown = () => {
    let that = this;

    this.portfolioRepo
      .getPortfolioAggregatesByAssetClasses(
        null,
        this.currency,
        "INTERNATIONAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.internationalAssetClass = val as Array<any>;

        this.internationalAssetClassesTotal =
          this.internationalAssetClass.reduce((prev, curr) => {
            return prev + curr.total;
          }, 0);
        this.topHoldings.setInternationalPortfolioValue(
          this.internationalAssetClassesTotal
        );
        this.internationalAssetSummaryChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                name: AssetClassNames.EQUITY,
                value: this.getInternationalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.internationalAssetClass,
                    AssetClassNames.EQUITY
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.EQUITY,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.FIXED_INCOME,
                value: this.getInternationalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.internationalAssetClass,
                    AssetClassNames.FIXED_INCOME
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.FIXED_INCOME,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.PRECIOUS_METALS,
                value: this.getInternationalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.internationalAssetClass,
                    AssetClassNames.PRECIOUS_METALS
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.PRECIOUS_METALS,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.ALTERNATIVE_INV,
                value: this.getInternationalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.internationalAssetClass,
                    AssetClassNames.ALTERNATIVE_INV
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.ALTERNATIVE_INV,
                    fontFamily: "Helvetica",
                  },
                },
              },
              {
                name: AssetClassNames.CASH,
                value: this.getInternationalAssetClassPercentage(
                  this.getAssetClassTotal(
                    this.internationalAssetClass,
                    AssetClassNames.CASH
                  )
                ),
                itemStyle: {
                  normal: {
                    color: AssetClassColour.CASH,
                    fontFamily: "Helvetica",
                  },
                },
              },
            ],
          },
        };

        // remove the 0 valued data from the pie chart
        that.internationalAssetSummaryChartOptions.series.data = _.filter(
          that.internationalAssetSummaryChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );

        that.internationalAssetSummaryChart.setOption(
          that.internationalAssetSummaryChartOptions
        );
      })
      .catch((err) => {});
  };

  formatLongNames = (name: string) => {
    let splitNames = name.split(" ");

    if (splitNames.length > 2) {
      for (var i = 0; i < splitNames.length - 1; i++) {
        if (i > 0 && i % 2 == 1) {
          splitNames[i] = splitNames[i] + "\n";
        }
      }
    }
    if (splitNames.length == 2) {
      splitNames[splitNames.length - 1] =
        splitNames[splitNames.length - 1] + "\n";
    }
    return splitNames.join(" ");
  };

  public getInternationalGeographyBreakdown = () => {
    this.portfolioRepo
      .getPortfolioAggregatesByGeography(
        this.currency,
        this.portfolioIds,
        this.toDate,
        "INTERNATIONAL",
        this.isReconciled
      )
      .then((result) => {
        this.internationalGeographyItems = _.reverse(
          _.orderBy(result, (item) => item.total)
        );

        let geographyItemsSorted = _.reverse(
          _.orderBy(this.internationalGeographyItems, (item) => {
            return item.total;
          })
        );
        let internationalTopGeographyInvestments: Array<any>;

        internationalTopGeographyInvestments = geographyItemsSorted.splice(
          0,
          5
        );
        let internationalOtherGeography = geographyItemsSorted.splice(
          0,
          geographyItemsSorted.length
        );

        if (internationalOtherGeography.length > 0) {
          let otherObject = {
            name: "Other",
            value: _.reduce(
              internationalOtherGeography,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
            total: _.reduce(
              internationalOtherGeography,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
          };

          internationalTopGeographyInvestments.push(otherObject);
        }

        this.internationalGeographyItems = internationalTopGeographyInvestments;

        var internationalGeographyPieChartData = new Array();
        let count = -1;
        internationalGeographyPieChartData = _.map(
          this.internationalGeographyItems,
          (item) => {
            count += 1;
            return {
              value: this.getInternationalGeographyPercentage(item),
              name: this.formatLongNames(item.name),
              itemStyle: {
                normal: {
                  color: GraphColourArray[count],
                  fontFamily: "Helvetica",
                },
              },
            };
          }
        );

        this.internationalGeographyChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: internationalGeographyPieChartData,
          },
        };
        // remove the 0 valued data from the pie chart
        this.internationalGeographyChartOptions.series.data = _.filter(
          this.internationalGeographyChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );

        this.internationalGeographyChart.setOption(
          this.internationalGeographyChartOptions
        );
        this.internationalGeographyColorArray =
          this.internationalGeographyChart.getOption().color;
      });
  };

  getInternationalGeographyTotal = () => {
    return _.reduce(
      this.internationalGeographyItems,
      (accumulator, item: any) => {
        accumulator += item.total;
        return accumulator;
      },
      0
    );
  };

  getInternationalGeographyPercentage = (item) => {
    return (item.total / this.getInternationalGeographyTotal()) * 100;
  };

  public getInternationalCurrencyBreakdown = () => {
    this.portfolioRepo
      .getPortfolioAggregatesByCurrency(
        this.currency,
        this.portfolioIds,
        this.toDate,
        "INTERNATIONAL",
        this.isReconciled
      )
      .then((result) => {
        this.getCurrencySplitBreakdown(); // Currency Split
        this.internationalCurrencyItems = _.reverse(
          _.orderBy(result, (item: any) => {
            return item.total;
          })
        );
        let currencyItemsSorted = _.reverse(
          _.orderBy(this.internationalCurrencyItems, (item) => {
            return item.total;
          })
        );
        let internationalTopCurrencyInvestments: Array<any>;

        internationalTopCurrencyInvestments = currencyItemsSorted.splice(0, 5);
        let internationalOtherSectors = currencyItemsSorted.splice(
          0,
          currencyItemsSorted.length
        );

        if (internationalOtherSectors.length > 0) {
          let otherObject = {
            name: "Other",
            value: _.reduce(
              internationalOtherSectors,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
            total: _.reduce(
              internationalOtherSectors,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
          };

          internationalTopCurrencyInvestments.push(otherObject);
        }

        this.internationalCurrencyItems = internationalTopCurrencyInvestments;

        var internationalCurrencyPieChartData = new Array();
        let count = -1;
        internationalCurrencyPieChartData = _.map(
          this.internationalCurrencyItems,
          (item) => {
            count += 1;
            return {
              value: this.getInternationalCurrencyPercentage(item),
              name: item.name,
              itemStyle: {
                normal: {
                  color: GraphColourArray[count],
                  fontFamily: "Helvetica",
                },
              },
            };
          }
        );

        this.internationalCurrencyChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: internationalCurrencyPieChartData,
          },
        };

        // remove the 0 valued data from the pie chart
        this.internationalCurrencyChartOptions.series.data = _.filter(
          this.internationalCurrencyChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );

        this.internationalCurrencyChart.setOption(
          this.internationalCurrencyChartOptions
        );

        this.internationalCurrencyColorArray =
          this.internationalCurrencyChart.getOption().color;
      });
  };

  public getCurrencySplitBreakdown = () => {
    this.portfolioRepo
      .getPortfolioAggregatesByCurrency(
        this.currency,
        this.portfolioIds,
        this.toDate,
        null,
        this.isReconciled
      )
      .then((result) => {
        this.currencyItems = _.reverse(
          _.orderBy(result, (item: any) => {
            return item.total;
          })
        ).filter((item) => item.total !== 0);
        let currencyItemsSorted = _.reverse(
          _.orderBy(this.currencyItems, (item) => {
            return item.total;
          })
        );
        let topCurrencyInvestments: Array<any>;

        topCurrencyInvestments = currencyItemsSorted.splice(0, 5);
        let otherSectors = currencyItemsSorted.splice(
          0,
          currencyItemsSorted.length
        );

        if (otherSectors.length > 0) {
          let otherObject = {
            name: "Other",
            value: _.reduce(
              otherSectors,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
            total: _.reduce(
              otherSectors,
              (accumulator, item: any) => {
                accumulator += item.total;
                return accumulator;
              },
              0
            ),
          };

          topCurrencyInvestments.push(otherObject);
        }

        this.currencyItems = topCurrencyInvestments;

        var currencyPieChartData = new Array();
        let count = -1;
        currencyPieChartData = _.map(this.currencyItems, (item) => {
          count += 1;
          return {
            value: this.getInternationalCurrencyPercentage(item),
            name: item.name,
            itemStyle: {
              normal: {
                color: GraphColourArray[count],
                fontFamily: "Helvetica",
              },
            },
          };
        });

        this.currencyChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          animation: false,
          avoidLabelOverlap: true,
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: 20,
                    fontFamily: "Seravek",
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            data: currencyPieChartData,
          },
        };

        // remove the 0 valued data from the pie chart
        this.currencyChartOptions.series.data = _.filter(
          this.currencyChartOptions.series.data,
          (item) => {
            return item.value > 0;
          }
        );

        this.currencyChart.setOption(this.currencyChartOptions);

        this.currencyColorArray = this.currencyChart.getOption().color;
      });
  };
  getInternationalCurrencyTotal = () => {
    return _.reduce(
      this.internationalCurrencyItems,
      (accumulator, item: any) => {
        accumulator += item.total;
        return accumulator;
      },
      0
    );
  };
  getCurrencyTotal = () => {
    return _.reduce(
      this.currencyItems,
      (accumulator, item: any) => {
        accumulator += item.total;
        return accumulator;
      },
      0
    );
  };

  getInternationalCurrencyPercentage = (item) => {
    return (item.total / this.getInternationalCurrencyTotal()) * 100;
  };

  getCurrencyPercentage = (item) => {
    return (item.total / this.getCurrencyTotal()) * 100;
  };

  getRegionalPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.regionalSummaryChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === item.name;
      }
    );
    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getAssetClassPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.assetSummaryChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === item.name;
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getLocalAssetClassPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.localAssetSummaryChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === item.name;
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getInternationalAssetClassPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.internationalAssetSummaryChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === item.name;
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getLocalSectorPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.localSectorChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === this.formatLongNames(item.name);
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getInternationalSectorPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.internationalSectorChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === this.formatLongNames(item.name);
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getInternationalGeographyPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.internationalGeographyChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === this.formatLongNames(item.name);
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getInternationalCurrencyPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.internationalCurrencyChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === this.formatLongNames(item.name);
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getCurrencyPieChartColours = (item) => {
    let itemInPieChart = _.filter(
      this.currencyChartOptions.series.data,
      (pieChartItem) => {
        return pieChartItem.name === this.formatLongNames(item.name);
      }
    );

    if (itemInPieChart.length > 0) {
      return _.first(itemInPieChart).itemStyle.normal.color;
    } else {
      return "white";
    }
  };

  getYear() {
    return this.toDate.getFullYear();
  }

  getLocalEquityList = async () => {
    await this.portfolioRepo
      .getPortfolioEquityItems(
        this.currency,
        "LOCAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.equityItemsLocal = val.data as Array<any>;
        const mergedSecurities = _(this.equityItemsLocal)
          .groupBy((obj) => obj.equityItem.id) // Group by 'id'
          .map((groups, id) => {
            return {
              ...groups[0], // Convert the key back to a number
              marketValueDisplayCurrency: _.sumBy(
                groups,
                (obj) => obj.marketValueDisplayCurrency
              ), // Sum up the 'value' property
              locality: Locality.Local,
              assetClass: AssetClassNames.EQUITY,
            };
          })
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.equityItemsLocal = _.filter(this.equityItemsLocal, (equity) => {
          return equity.marketValueDisplayCurrency > 0;
        });
        this.equityItemsLocal = _.orderBy(
          this.equityItemsLocal,
          (equity: any) => {
            if (isNullOrUndefined(equity.sector)) {
              equity.sector = {
                name: "Unknown",
              };
            }
            return equity.sector.name;
          }
        );
        this.equitiesTotalLocal = _.reduce(
          this.equityItemsLocal,
          (prev, equity) => {
            return prev + equity.marketValueDisplayCurrency;
          },
          0
        );

        while (this.equityItemsLocal.length > 0) {
          this.equityItemsListLocal.push(
            this.equityItemsLocal.splice(0, this.tableItemsSize)
          );
        }

        for (var i = 0; i < this.equityItemsListLocal.length; i++) {
          this.equityItemsListLocal[i] = this.groupBalancesBySector(
            this.equityItemsListLocal[i]
          );
        }
      })
      .catch((err) => {});
  };

  getLocalEquityPercentage = (equity: any) => {
    return (equity.marketValueDisplayCurrency / this.mauritiusTotal) * 100;
  };

  getInternationalEquityList = async () => {
    await this.portfolioRepo
      .getPortfolioEquityItems(
        this.currency,
        "INTERNATIONAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.equityItemsInternational = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.equityItemsInternational)
          .groupBy((obj) => obj.equityItem.id) // Group by 'id'
          .map((groups, id) => {
            return {
              ...groups[0],
              marketValueDisplayCurrency: _.sumBy(
                groups,
                (obj) => obj.marketValueDisplayCurrency
              ),
              locality: Locality.International,
              assetClass: AssetClassNames.EQUITY,
            };
          })
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.equityItemsInternational = _.filter(
          this.equityItemsInternational,
          (equity) => {
            return equity.marketValueDisplayCurrency > 0;
          }
        );
        this.equityItemsInternational = _.orderBy(
          this.equityItemsInternational,
          (equity: any) => {
            if (isNullOrUndefined(equity.sector)) {
              equity.sector = {
                name: "Unknown",
              };
            }
            return equity.sector.name;
          }
        );
        this.equitiesTotalInternational = _.reduce(
          this.equityItemsInternational,
          (prev, equity) => {
            return prev + equity.marketValueDisplayCurrency;
          },
          0
        );

        while (this.equityItemsInternational.length > 0) {
          this.equityItemsListInternational.push(
            this.equityItemsInternational.splice(0, this.tableItemsSize)
          );
        }
        for (var i = 0; i < this.equityItemsListInternational.length; i++) {
          this.equityItemsListInternational[i] = this.groupBalancesBySector(
            this.equityItemsListInternational[i]
          );
        }
      })
      .catch((err) => {});
  };

  getInternationalEquityPercentage = (equity: any) => {
    return (equity.marketValueDisplayCurrency / this.internationalTotal) * 100;
  };

  getLocalFixedIncomeList = async () => {
    await this.portfolioRepo
      .getPortfolioFixedIncomeItems(
        this.currency,
        "LOCAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.fixedIncomeItemsLocal = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.fixedIncomeItemsLocal)
          .groupBy((obj) => obj.fixedIncomeItem.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.Local,
            assetClass: AssetClassNames.FIXED_INCOME,
          }))
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.fixedIncomeItemsLocal = _.filter(
          this.fixedIncomeItemsLocal,
          (fixedIncome) => {
            return fixedIncome.marketValueDisplayCurrency > 0;
          }
        );
        this.fixedIncomeItemsLocal = _.orderBy(
          this.fixedIncomeItemsLocal,
          (fixedIncome: any) => {
            return fixedIncome.portfolio.name;
          }
        );

        this.fixedIncomeTotalLocal = _.reduce(
          this.fixedIncomeItemsLocal,
          (prev, fixedIncome) => {
            return prev + fixedIncome.marketValueDisplayCurrency;
          },
          0
        );

        while (this.fixedIncomeItemsLocal.length > 0) {
          this.fixedIncomeItemsListLocal.push(
            this.fixedIncomeItemsLocal.splice(0, this.tableItemsSize)
          );
        }
      })
      .catch((err) => {});
  };

  getLocalFixedIncomePercentage(fixedIncome: any) {
    return (fixedIncome.marketValueDisplayCurrency / this.mauritiusTotal) * 100;
  }

  getInternationalFixedIncomeList = async () => {
    await this.portfolioRepo
      .getPortfolioFixedIncomeItems(
        this.currency,
        "INTERNATIONAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.fixedIncomeItemsInternational = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.fixedIncomeItemsInternational)
          .groupBy((obj) => obj.fixedIncomeItem.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.International,
            assetClass: AssetClassNames.FIXED_INCOME,
          }))
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.fixedIncomeItemsInternational = _.filter(
          this.fixedIncomeItemsInternational,
          (fixedIncome) => {
            return fixedIncome.marketValueDisplayCurrency > 0;
          }
        );
        this.fixedIncomeItemsInternational = _.orderBy(
          this.fixedIncomeItemsInternational,
          (fixedIncome: any) => {
            return fixedIncome.portfolio.name;
          }
        );

        this.fixedIncomeTotalInternational = _.reduce(
          this.fixedIncomeItemsInternational,
          (prev, fixedIncome) => {
            return prev + fixedIncome.marketValueDisplayCurrency;
          },
          0
        );

        while (this.fixedIncomeItemsInternational.length > 0) {
          this.fixedIncomeItemsListInternational.push(
            this.fixedIncomeItemsInternational.splice(0, this.tableItemsSize)
          );
        }
      })
      .catch((err) => {});
  };

  getInternationalFixedIncomePercentage(fixedIncome: any) {
    return (
      (fixedIncome.marketValueDisplayCurrency / this.internationalTotal) * 100
    );
  }

  getLocalPreciousMetalList = async () => {
    await this.portfolioRepo
      .getPortfolioPreciousMetalItems(
        this.currency,
        "LOCAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.preciousMetalItemsLocal = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.preciousMetalItemsLocal)
          .groupBy((obj) => obj.preciousMetalItem.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.Local,
            assetClass: AssetClassNames.PRECIOUS_METALS,
          }))
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.preciousMetalItemsLocal = _.filter(
          this.preciousMetalItemsLocal,
          (preciousMetal) => {
            return preciousMetal.marketValueDisplayCurrency > 0;
          }
        );
        this.preciousMetalItemsLocal = _.orderBy(
          this.preciousMetalItemsLocal,
          (preciousMetal: any) => {
            return preciousMetal.portfolio.name;
          }
        );

        this.preciousMetalsTotalLocal = _.reduce(
          this.preciousMetalItemsLocal,
          (prev, preciousMetal) => {
            return prev + preciousMetal.marketValueDisplayCurrency;
          },
          0
        );

        while (this.preciousMetalItemsLocal.length > 0) {
          this.preciousMetalItemsListLocal.push(
            this.preciousMetalItemsLocal.splice(0, this.tableItemsSize)
          );
        }
      })
      .catch(() => {});
  };

  getLocalPreciousMetalPercentage(preciousMetal: any) {
    return (
      (preciousMetal.marketValueDisplayCurrency / this.mauritiusTotal) * 100
    );
  }

  getInternationalPreciousMetalList = async () => {
    await this.portfolioRepo
      .getPortfolioPreciousMetalItems(
        this.currency,
        "INTERNATIONAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.preciousMetalItemsInternational = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.preciousMetalItemsInternational)
          .groupBy((obj) => obj.preciousMetalItem.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.International,
            assetClass: AssetClassNames.PRECIOUS_METALS,
          }))
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.preciousMetalItemsInternational = _.filter(
          this.preciousMetalItemsInternational,
          (preciousMetal) => {
            return preciousMetal.marketValueDisplayCurrency > 0;
          }
        );
        this.preciousMetalItemsInternational = _.orderBy(
          this.preciousMetalItemsInternational,
          (preciousMetal: any) => {
            return preciousMetal.portfolio.name;
          }
        );

        this.preciousMetalsTotalInternational = _.reduce(
          this.preciousMetalItemsInternational,
          (prev, preciousMetal) => {
            return prev + preciousMetal.marketValueDisplayCurrency;
          },
          0
        );

        while (this.preciousMetalItemsInternational.length > 0) {
          this.preciousMetalItemsListInternational.push(
            this.preciousMetalItemsInternational.splice(0, this.tableItemsSize)
          );
        }
      })
      .catch(() => {});
  };

  getInternationalPreciousMetalPercentage(preciousMetal: any) {
    return (
      (preciousMetal.marketValueDisplayCurrency / this.internationalTotal) * 100
    );
  }

  getLocalAlternativeInvestmentsList = async () => {
    await this.portfolioRepo
      .getPortfolioAlternativeInvestmentItems(
        this.currency,
        "LOCAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.alternativeInvestmentItemsLocal = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.alternativeInvestmentItemsLocal)
          .groupBy((obj) => obj.alternativeInvestmentItem.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.Local,
            assetClass: AssetClassNames.ALTERNATIVE_INV,
          }))
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.alternativeInvestmentItemsLocal = _.filter(
          this.alternativeInvestmentItemsLocal,
          (alternativeInvestment) => {
            return alternativeInvestment.marketValueDisplayCurrency > 0;
          }
        );
        this.alternativeInvestmentItemsLocal = _.orderBy(
          this.alternativeInvestmentItemsLocal,
          (alternativeInvestment: any) => {
            return alternativeInvestment.portfolio.name;
          }
        );

        this.alternativeInvestmentsTotalLocal = _.reduce(
          this.alternativeInvestmentItemsLocal,
          (prev, alternativeInvestment) => {
            return prev + alternativeInvestment.marketValueDisplayCurrency;
          },
          0
        );

        while (this.alternativeInvestmentItemsLocal.length > 0) {
          this.alternativeInvestmentItemsListLocal.push(
            this.alternativeInvestmentItemsLocal.splice(0, this.tableItemsSize)
          );
        }
      })
      .catch(() => {});
  };

  getLocalAlternativeInvestmentPercentage(alternativeInvestment: any) {
    return (
      (alternativeInvestment.marketValueDisplayCurrency / this.mauritiusTotal) *
      100
    );
  }

  getInternationalAlternativeInvestmentList = async () => {
    await this.portfolioRepo
      .getPortfolioAlternativeInvestmentItems(
        this.currency,
        "INTERNATIONAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.alternativeInvestmentItemsInternational = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.alternativeInvestmentItemsInternational)
          .groupBy((obj) => obj.alternativeInvestmentItem.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.International,
            assetClass: AssetClassNames.ALTERNATIVE_INV,
          }))
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.alternativeInvestmentItemsInternational = _.filter(
          this.alternativeInvestmentItemsInternational,
          (alternativeInvestment) => {
            return alternativeInvestment.marketValueDisplayCurrency > 0;
          }
        );
        this.alternativeInvestmentItemsInternational = _.orderBy(
          this.alternativeInvestmentItemsInternational,
          (alternativeInvestment: any) => {
            return alternativeInvestment.portfolio.name;
          }
        );

        this.alternativeInvestmentsTotalInternational = _.reduce(
          this.alternativeInvestmentItemsInternational,
          (prev, alternativeInvestment) => {
            return prev + alternativeInvestment.marketValueDisplayCurrency;
          },
          0
        );

        while (this.alternativeInvestmentItemsInternational.length > 0) {
          this.alternativeInvestmentItemsListInternational.push(
            this.alternativeInvestmentItemsInternational.splice(
              0,
              this.tableItemsSize
            )
          );
        }
      })
      .catch(() => {});
  };

  getInternationalAlternativeInvestmentPercentage(alternativeInvestment: any) {
    return (
      (alternativeInvestment.marketValueDisplayCurrency /
        this.internationalTotal) *
      100
    );
  }

  getLocalCashItemsList = async () => {
    await this.portfolioRepo
      .getPortfolioCashItems(
        this.currency,
        "LOCAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.cashItemsLocal = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.cashItemsLocal)
          .groupBy((obj) => obj.cashAccount.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.Local,
            assetClass: AssetClassNames.CASH,
          }))
          .value();
        this.allPortfolioHoldings = _.concat(
          this.allPortfolioHoldings,
          mergedSecurities
        );
        this.cashItemsLocal = _.orderBy(this.cashItemsLocal, (cash: any) => {
          return cash.portfolio.name;
        });
        this.cashTotalLocal = _.reduce(
          this.cashItemsLocal,
          (prev, cash) => {
            return prev + cash.marketValueDisplayCurrency;
          },
          0
        );

        while (this.cashItemsLocal.length > 0) {
          this.cashItemsListLocal.push(
            this.cashItemsLocal.splice(0, this.tableItemsSize)
          );
        }
      })
      .catch((err) => {});
  };

  getLocalCashPercentage(cash: any) {
    return (cash.marketValueDisplayCurrency / this.mauritiusTotal) * 100;
  }

  getInternationalCashItemsList = async () => {
    await this.portfolioRepo
      .getPortfolioCashItems(
        this.currency,
        "INTERNATIONAL",
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((val) => {
        this.cashItemsInternational = val.data as Array<any>;
        /**
         * If there are duplicate securities, merge them but SUM UP their total
         */
        const mergedSecurities = _(this.cashItemsInternational)
          .groupBy((obj) => obj.cashAccount.id) // Group by 'id'
          .map((groups, id) => ({
            ...groups[0],
            marketValueDisplayCurrency: _.sumBy(
              groups,
              (obj) => obj.marketValueDisplayCurrency
            ),
            locality: Locality.International,
            assetClass: AssetClassNames.CASH,
          }))
          .value();
        this.cashItemsInternational = _.orderBy(
          this.cashItemsInternational,
          (cash: any) => {
            return cash.portfolio.name;
          }
        );
        this.cashTotalInternational = _.reduce(
          this.cashItemsInternational,
          (prev, cash) => {
            return prev + cash.marketValueDisplayCurrency;
          },
          0
        );

        while (this.cashItemsInternational.length > 0) {
          this.cashItemsListInternational.push(
            this.cashItemsInternational.splice(0, this.tableItemsSize)
          );
        }
      })
      .catch((err) => {});
  };

  getInceptionPerf = () => {
    if (!this.currency) {
      this.currency = "MUR";
    }
    this.portfolioRepo
      .getInceptionPerformance(
        this.currency,
        this.$stateParams["clientNumber"],
        this.portfolioIds,
        this.toDate,
        this.isReconciled
      )
      .then((res) => {
        this.inceptionPerfItems = res.data;
        // console.log(this.inceptionPerfItems.performanceGraph);
        this.inceptionPerformanceChartOptions = {
          title: {
            text: ``,
          },
          animation: false,
          color: [this.confidentBrown, this.confidentGrey],
          legend: {
            show: true,
            type: "scroll",
            orient: "horizontal",
            textStyle: {
              fontSize: "22",
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            data: this.inceptionPerfItems.performanceGraph.map(
              (perf) => perf.year
            ),
            axisLabel: {
              fontSize: "22",
            },
          },
          yAxis: {
            type: "value",
            // data: this.inceptionPerfItems.PerformanceGraph.map(
            //   (perf) => perf.year
            // ),
            axisLabel: {
              fontSize: "22",
            },
          },
          series: [
            {
              type: "bar",
              name: "Yearly Combined Performance (%)",
              data: this.inceptionPerfItems.performanceGraph.map((perf) =>
                (perf.performance * 100).toFixed(2)
              ),
              label: {
                show: true,
                formatter: "{c}%",
                position: "top",
                textStyle: {
                  fontSize: "22",
                },
              },
            },
            {
              type: "line",
              name: "Cumulative Combined Performance (%)",
              data: this.inceptionPerfItems.performanceGraph.map(
                (perf) => perf.cumulativePerformance * 100
              ),
            },
          ],
        };
        this.inceptionPerformanceChart.setOption(
          this.inceptionPerformanceChartOptions
        );
        // console.log(res.data);
        // console.log(this.inceptionPerformanceChartOptions);
      })
      .catch((err) => {});
  };

  getInternationalCashPercentage(cash: any) {
    return (cash.marketValueDisplayCurrency / this.internationalTotal) * 100;
  }

  getUnrealisedGainLossPercentage(item) {
    if (item.unrealisedGainLossPercentage) {
      if (item.unrealisedGainLossPercentage == -100) {
        return "0 ";
      }
      return item.unrealisedGainLossPercentage.toFixed(2);
    }
    return "- ";
    // return item.unrealisedGainLossPercentage
    //   ? item.unrealisedGainLossPercentage.toFixed(2)
    //   : "- ";
  }

  getYtdGainLossPercentage(item) {
    if (item.yearToDateGainLossPercentage) {
      if (item.yearToDateGainLossPercentage == -100) {
        return "0 ";
      }
      return item.yearToDateGainLossPercentage.toFixed(2);
    }
    return "- ";
    // return item.yearToDateGainLossPercentage
    //   ? item.yearToDateGainLossPercentage.toFixed(2)
    //   : "- ";
  }

  groupBalancesBySector = (balances) => {
    let balancesBySector = {};
    let tempGroupedEquities = {};
    for (var s of balances) {
      // Set the default sector name in case a sector is not defined for the item.
      let sectorName = "Unknown";

      // Check if the item has a sector and set sector name accordingly if it does.
      if (s.sector != null) {
        sectorName = s.sector.name;
      }

      // Make sure that we have this sector in our list of equities by sector.
      if (!tempGroupedEquities.hasOwnProperty(sectorName)) {
        tempGroupedEquities[sectorName] = new Array();
      }

      // Add the equity to its sector.
      tempGroupedEquities[sectorName].push(s);
    }
    let keys = _.keys(tempGroupedEquities).sort();
    keys.forEach((k) => {
      balancesBySector[k] = {
        items: tempGroupedEquities[k],
        name: k,
        totalMarketValue: _.reduce(
          tempGroupedEquities[k],
          (sum, n) => {
            return sum + n.marketValueDisplayCurrency;
          },
          0
        ),
      };
    });

    return balancesBySector;
  };

  public getAssetClassTotal(assetClassTotals, assetClassName) {
    let assetClassTotal = assetClassTotals.find(
      (assetClass) => assetClass.name == assetClassName
    );
    return assetClassTotal == undefined || assetClassTotal == null
      ? 0
      : assetClassTotal;
  }

  public getUnreconciledReportText = () => {
    return !this.isReconciled ? "(Unreconciled) " : "";
  };

  public getBenchmarkPortfolioPerformance() {
    if (!this.currency) {
      this.currency = "MUR";
    }
    this.portfolioRepo
      .getPortfolioPerformance(
        this.currency,
        this.portfolioIds,
        null,
        this.toDate,
        this.isReconciled
      )
      .then((response) => {
        let data: Array<PortfolioPerformance> =
          response.data as Array<PortfolioPerformance>;

        let benchmarkPerformanceLocal: Array<BenchmarkPerformance> = [];
        let benchmarkPerformanceInternational: Array<BenchmarkPerformance> = [];
        let benchmarkPerformanceCombined: Array<BenchmarkPerformance> = [];

        let monthToDateLocal: BenchmarkPerformance = {
          title: "Month to Date",
          portfolioPerformance: data[0].benchmarkParameter.monthToDate,
          benchmarkPerformancePrimary:
            data[0].benchmarkParameter.monthToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[0].benchmarkParameter.monthToDateSecondaryBenchmark,
        };
        let quarterToDateLocal: BenchmarkPerformance = {
          title: "Quarter to Date",
          portfolioPerformance: data[0].benchmarkParameter.quarterToDate,
          benchmarkPerformancePrimary:
            data[0].benchmarkParameter.quarterToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[0].benchmarkParameter.quarterToDateSecondaryBenchmark,
        };
        let yearToDateLocal: BenchmarkPerformance = {
          title: "YTD",
          portfolioPerformance: data[0].benchmarkParameter.yearToDate,
          benchmarkPerformancePrimary:
            data[0].benchmarkParameter.yearToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[0].benchmarkParameter.yearToDateSecondaryBenchmark,
        };
        let ttmToDateLocal: BenchmarkPerformance = {
          title: "TTM",
          portfolioPerformance: data[0].benchmarkParameter.trailingTwelveMonths,
          benchmarkPerformancePrimary:
            data[0].benchmarkParameter.trailingTwelveMonthsPrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[0].benchmarkParameter.trailingTwelveMonthsSecondaryBenchmark,
        };

        benchmarkPerformanceLocal.push(monthToDateLocal);
        benchmarkPerformanceLocal.push(quarterToDateLocal);
        benchmarkPerformanceLocal.push(yearToDateLocal);
        benchmarkPerformanceLocal.push(ttmToDateLocal);

        let monthToDateInternational: BenchmarkPerformance = {
          title: "Month to Date",
          portfolioPerformance: data[1].benchmarkParameter.monthToDate,
          benchmarkPerformancePrimary:
            data[1].benchmarkParameter.monthToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[1].benchmarkParameter.monthToDateSecondaryBenchmark,
        };
        let quarterToDateInternational: BenchmarkPerformance = {
          title: "Quarter to Date",
          portfolioPerformance: data[1].benchmarkParameter.quarterToDate,
          benchmarkPerformancePrimary:
            data[1].benchmarkParameter.quarterToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[1].benchmarkParameter.quarterToDateSecondaryBenchmark,
        };
        let yearToDateInternational: BenchmarkPerformance = {
          title: "YTD",
          portfolioPerformance: data[1].benchmarkParameter.yearToDate,
          benchmarkPerformancePrimary:
            data[1].benchmarkParameter.yearToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[1].benchmarkParameter.yearToDateSecondaryBenchmark,
        };
        let ttmToDateInternational: BenchmarkPerformance = {
          title: "TTM",
          portfolioPerformance: data[1].benchmarkParameter.trailingTwelveMonths,
          benchmarkPerformancePrimary:
            data[1].benchmarkParameter.trailingTwelveMonthsPrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[1].benchmarkParameter.trailingTwelveMonthsSecondaryBenchmark,
        };

        benchmarkPerformanceInternational.push(monthToDateInternational);
        benchmarkPerformanceInternational.push(quarterToDateInternational);
        benchmarkPerformanceInternational.push(yearToDateInternational);
        benchmarkPerformanceInternational.push(ttmToDateInternational);      

        let monthToDateCombined: BenchmarkPerformance = {
          title: "Month to Date",
          portfolioPerformance: data[2].benchmarkParameter.monthToDate,
          benchmarkPerformancePrimary:
            data[2].benchmarkParameter.monthToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[2].benchmarkParameter.monthToDateSecondaryBenchmark,
        };
        let quarterToDateCombined: BenchmarkPerformance = {
          title: "Quarter to Date",
          portfolioPerformance: data[2].benchmarkParameter.quarterToDate,
          benchmarkPerformancePrimary:
            data[2].benchmarkParameter.quarterToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[2].benchmarkParameter.quarterToDateSecondaryBenchmark,
        };
        let yearToDateCombined: BenchmarkPerformance = {
          title: "YTD",
          portfolioPerformance: data[2].benchmarkParameter.yearToDate,
          benchmarkPerformancePrimary:
            data[2].benchmarkParameter.yearToDatePrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[2].benchmarkParameter.yearToDateSecondaryBenchmark,
        };
        let ttmToDateCombined: BenchmarkPerformance = {
          title: "TTM",
          portfolioPerformance: data[2].benchmarkParameter.trailingTwelveMonths,
          benchmarkPerformancePrimary:
            data[2].benchmarkParameter.trailingTwelveMonthsPrimaryBenchmark,
          benchmarkPerformanceSecondary:
            data[2].benchmarkParameter.trailingTwelveMonthsSecondaryBenchmark,
        };

        benchmarkPerformanceCombined.push(monthToDateCombined);
        benchmarkPerformanceCombined.push(quarterToDateCombined);
        benchmarkPerformanceCombined.push(yearToDateCombined);
        benchmarkPerformanceCombined.push(ttmToDateCombined);

        this.benchmarkPerformancePortfolio.local = benchmarkPerformanceLocal;
        this.benchmarkPerformancePortfolio.international =
          benchmarkPerformanceInternational;
        this.benchmarkPerformancePortfolio.combined =
          benchmarkPerformanceCombined;

        this.getFinancialYearToDatePerformance();
      })
      .catch((error) => {});
  }

  public isNullOrWhitespace(input: string | null | undefined): boolean {
    return !input || input.trim().length === 0;
  }

  public setBenchmarkColumns() {
    this.primaryBenchmarkColumnName =
      this.client.primaryBenchmarkColumnName === null ||
      this.client.primaryBenchmarkColumnName === undefined
        ? ClientBenchmarkColumnNames.DefaultBenchmark
        : this.client.primaryBenchmarkColumnName;
    this.secondaryBenchmarkColumnName =
      this.client.secondaryBenchmarkColumnName === null ||
      this.client.secondaryBenchmarkColumnName === undefined
        ? ""
        : this.client.secondaryBenchmarkColumnName;
    this.isSecondaryBenchmarkColumnEnabled =
      this.client.isSecondaryBenchmarkColumnEnabled === null ||
      this.client.isSecondaryBenchmarkColumnEnabled === undefined ||
      this.isNullOrWhitespace(this.secondaryBenchmarkColumnName)
        ? false
        : this.client.isSecondaryBenchmarkColumnEnabled;
  }
  public setStrategyGoingForward() {
    this.strategyInformation.localStrategy = this.client.localStrategy
      .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
      .replace(/  /g, "&nbsp;&nbsp;");
    this.strategyInformation.internationalStrategy =
      this.client.internationalStrategy
        .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
        .replace(/  /g, "&nbsp;&nbsp;");

    this.strategyInformation.isLocalStrategyEnabled =
      this.client.isLocalStrategyEnabled;

    this.strategyInformation.isInternationalStrategyEnabled =
      this.client.isInternationalStrategyEnabled;

    this.strategyInformation.isCombinedStrategyEnabled =
      this.client.isCombinedStrategyEnabled;
  }
  public getLastTransactions() {
    this.portfolioRepo
      .getLastTransactionsForPortfolios(this.portfolioIds, this.toDate)
      .then((result) => {
        let lastTransactions = result.data as Array<LastTransactionDTO>;
        this.lastTransactionPortfolio.combined = lastTransactions
          .map((tx) => {
            let lastTx: LastTransaction = {
              description: tx.reportDescription,
              operationDescription: tx.operationDescription,
              amount: tx.amount,
            };
            return lastTx;
          })
          .sort((a, b) => b.amount - a.amount);
      });
  }
  calculateColumnClass = function () {
    return this.combinedBenchmarkSecondary ? "col-md-3" : "col-md-4";
  };

  public getPortfolioAttributionGraphs() {
    this.attributionRepo
      .getQuarterDates(moment().format("YYYY-MM-DD"))
      .then((res) => {
        this.quarterDates = res.data as any;
      })
      .catch((e) => {})
      .finally(() => {
        if (this.allPortfolioAttributionDataReturned()) {
        }
      });

    this.getAssetClassContributionCurrentQuarter();
    this.getAssetClassContributionTTM();
    this.getAttributionByInvestments();
  }

  private getAssetClassContributionTTM() {
    this.attributionRepo
      .getAssetClassContributionTTM(this.currency, this.portfolioIds)
      .then((res) => {
        this.assetClassPerformanceTTM = res.data as AssetClassPerformance[];
        defaultAssetClassNames.forEach((el) => {
          let searchVariable = el.longName;
          if (el.longName === "Cash And Money Market") {
            searchVariable = "Cash";
          }
          if (el.longName === "Alternative Investments") {
            searchVariable = "Alternative Inv";
          }
          let perfTTM = this.assetClassPerformanceTTM.find(
            (x) => x.name === searchVariable
          );
          let attributionTTM = this.attributionByAssetClass.find(
            (x) => x.name === el.longName
          );

          if (perfTTM !== undefined) {
            if (attributionTTM !== undefined) {
              attributionTTM.performance = perfTTM.performance;
            }
          }
        });

        defaultAssetClassNames.forEach((el) => {
          let searchVariable = el.longName;
          if (el.longName === "Cash And Money Market") {
            searchVariable = "Cash";
          }
          if (el.longName === "Alternative Investments") {
            searchVariable = "Alternative Inv";
          }
          let perfTTM = this.assetClassPerformanceTTM.find(
            (x) => x.name === searchVariable
          );
          let attributionTTM = this.attributionByAssetClass.find(
            (x) => x.name === el.longName
          );

          if (perfTTM !== undefined) {
            if (attributionTTM !== undefined) {
              attributionTTM.performance = perfTTM.performance;
            }
          }
        });
      })
      .catch()
      .finally(() => {
        if (this.allPortfolioAttributionDataReturned()) {
          this.intitializeQuarterGraph();
          this.intitializeTTMGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  private getAssetClassContributionCurrentQuarter() {
    this.attributionRepo
      .getAssetClassContributionCurrentQuarter(this.currency, this.portfolioIds)
      .then((res) => {
        this.assetClassPerformanceQuarter = res.data as AssetClassPerformance[];
      })
      .catch((e) => {})
      .finally(() => {
        if (this.allPortfolioAttributionDataReturned()) {
          this.intitializeQuarterGraph();
          this.intitializeTTMGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  public getAttributionByInvestments() {
    this.isFetchingPortfolioAttributions = true;
    const variables = _.cloneDeep(defaultAssetClassNames);
    this.attributionRepo
      .getPortfolioAttributionByInvestment(
        this.$stateParams["clientNumber"],
        this.portfolioIds,
        this.currency
      )
      .then((res) => {
        this.attributionContributions =
          res.data as PortfolioAttributionContribution;
        variables.forEach((el) => {
          let perf = 0;
          if (
            !!this.attributionContributions.assetClassBenchmarkPerformance[
              el.dtoName
            ]
          ) {
            perf =
              this.attributionContributions.assetClassBenchmarkPerformance[
                el.dtoName
              ];
          }
          let attributionTTM = this.attributionByAssetClass.find(
            (x) => x.name === el.longName
          );
          attributionTTM.benchmarkPerformance = perf;
        });
      })
      .catch((err) => {})
      .finally(() => {
        this.isFetchingPortfolioAttributions = false;
        if (this.allPortfolioAttributionDataReturned()) {
          this.intitializeTTMGraph();
          this.intitializeQuarterGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  public intitializeTTMGraph() {
    let labels = this.assetClassPerformanceTTM.map((p) => p.name);
    let performances = this.assetClassPerformanceTTM.map((p) =>
      this.getChartOptionsBarStylingObject(p.performance)
    );
    this.assetClassTtmPerfGraph.setOption({
      title: {
        text: "Contribution by Asset Classes - TTMs",
      },
      ...getWaterfallOptions(labels, performances),
    });
  }

  public intitializeQuarterGraph() {
    let labels = this.assetClassPerformanceQuarter.map((p) => p.name);
    let performances = this.assetClassPerformanceQuarter.map((p) =>
      this.getChartOptionsBarStylingObject(p.performance)
    );

    this.quarterEndDate = moment(
      this.quarterDates.currentQuarter.endDate.toString()
    ).format("MMM yyyy");

    this.assetClassQuarterPerfGraph.setOption({
      title: {
        text: `Contribution by Asset Class -  Quarter ending ${this.quarterEndDate}`,
      },
      ...getWaterfallOptions(labels, performances),
    });
  }

  getChartOptionsBarStylingObject(value: number) {
    if (value > 0)
      return new BarChartStyleOption(
        Math.round((value * 100 + Number.EPSILON) * 100) / 100,
        "#b2d979"
      );
    else
      return new BarChartStyleOption(
        Math.round((value * 100 + Number.EPSILON) * 100) / 100,
        "#ed432c"
      );
  }

  public intitializeAttributionByAssetClassGraph() {
    this.attributionByAssetClassGraph.setOption(
      getNegativeBarGraphOptions(this.attributionByAssetClass)
    );
  }

  private allPortfolioAttributionDataReturned() {
    let result =
      this.quarterDates &&
      this.assetClassPerformanceQuarter.length &&
      this.assetClassPerformanceTTM.length &&
      this.isFetchingPortfolioAttributions === false;
    return result;
  }

  public setGlobalParams() {
    var date = new Date();
    this.fromDate = moment().startOf("year").format("YYYY-MM-DD");
    this.toDate = moment(date).format("YYYY-MM-DD");

    // Set the list of portfolioIds:
    this.portfolioIds = this.$stateParams["portfolioIds"]
      .split(",")
      .map((portfolioId) => {
        return +portfolioId;
      });

    // Set the currency if not null or empty.
    // Default value already set to 'MUR'.
    if (
      this.$stateParams["currency"] != null &&
      this.$stateParams["currency"] != ""
    ) {
      this.currency = this.$stateParams["currency"];
    }

    // Set the fromDate if not null or empty.
    if (!isNullOrUndefined(this.$stateParams.fromDate)) {
      this.fromDate = this.$stateParams.fromDate;
    }

    // Set the toDate if not null or empty.
    if (!isNullOrUndefined(this.$stateParams.toDate)) {
      this.toDate = moment(this.$stateParams.toDate).format("YYYY-MM-DD");
    }
  }

  public isReportForPortfolioSummary() {
    this.showPortfolioSummaryReportOnly = !(
      (this.$stateParams.portfolioAttribution as string).toLowerCase() ===
      "true"
    );
    return this.showPortfolioSummaryReportOnly;
  }

  private initializePortfolioSummaryGraphs() {
    this.topHoldings.initializeCharts();

    this.regionalSummaryChart = echarts.init(
      document.getElementById("regional-summary-pie-chart")
    );

    this.assetSummaryChart = echarts.init(
      document.getElementById("asset-summary-pie-chart")
    );

    this.localAssetSummaryChart = echarts.init(
      document.getElementById("mauritius-asset-summary-pie-chart")
    );

    this.localSectorChart = echarts.init(
      document.getElementById("mauritius-sector-summary-pie-chart")
    );

    this.internationalAssetSummaryChart = echarts.init(
      document.getElementById("international-asset-summary-pie-chart")
    );

    this.internationalGeographyChart = echarts.init(
      document.getElementById("international-geography-summary-pie-chart")
    );

    this.internationalCurrencyChart = echarts.init(
      document.getElementById("international-currency-summary-pie-chart")
    );

    this.inceptionPerformanceChart = echarts.init(
      document.getElementById("performance-inception-bar-chart")
    );

    this.currencyChart = echarts.init(
      document.getElementById("total-portfolio-currency-split-pie-chart")
    );
  }
  private initializePortfolioAttributionGraphs() {
    this.assetClassTtmPerfGraph = echarts.init(
      document.getElementById("asset-class-ttm-contribution-waterfall-chart")
    );

    this.assetClassQuarterPerfGraph = echarts.init(
      document.getElementById(
        "asset-class-quarter-contribution-waterfall-chart"
      )
    );

    this.attributionByAssetClassGraph = echarts.init(
      document.getElementById("attribution-by-asset-class-bar-chart")
    );
  }
}

export const portfolioSummaryReport: angular.IComponentOptions = {
  template: require("./report.html"),
  controller: PortfolioSummaryReportController,
};



// WEBPACK FOOTER //
// ./src/app/reporting/portfolio/report.ts